import { SHOW_TOP_PLACES } from "../action/Action";

const initialState = {
    placeData: [],
}

const topPlaceActionReducer = (state = initialState, action) => {
    switch (action?.type) {
        case SHOW_TOP_PLACES:
            return {
                ...state,
                placeData: action?.payload
            };
        default:
            return state;
    }
}

export default topPlaceActionReducer;